import { render } from "./AreaOfLawForm.vue?vue&type=template&id=ffbc445e&ts=true"
import script from "./AreaOfLawForm.vue?vue&type=script&lang=ts"
export * from "./AreaOfLawForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__